export default "__VITE_ASSET__b8c59ddb__"